'use strict';

/**
 *
 * @param {*} productItemSelector product item selector
 * @param {*} gridContainerSelector grid selector
 * @returns {null | number} grid row position
 */
const getProductItemRow = (productItemSelector, gridContainerSelector) => {
    const productItem = $(productItemSelector);
    const gridContainer = $(gridContainerSelector);

    const $baseTile = $('.product-item-wrapper').first();
    let cellHeight = $baseTile.outerHeight();
    let cellWidth = $baseTile.outerWidth();

    if (cellHeight === 0 || cellWidth === 0) {
        cellHeight = gridContainer.outerHeight() / gridContainer.children().length;
        cellWidth = gridContainer.outerWidth() / gridContainer.children().length;
        if (Number.isNaN(cellHeight) || Number.isNaN(cellWidth) || cellHeight === 0 || cellWidth === 0) {
            return null;
        }
    }

    const offset = productItem.offset();
    if (!offset) {
        return null;
    }
    const gridOffset = gridContainer.offset();

    const topOffsetDiff = offset.top - gridOffset.top;

    const rowIndex = Math.max(1, Math.floor(topOffsetDiff / cellHeight) + 1);

    return rowIndex;
};

/**
 *
 * @param {*} tile product item selector
 * @param {*} grid grid selector
 * @returns {null | number} grid row position
 */
const getMarketingTileRow = (tile, grid) => {
    const $tile = $(tile);
    const $grid = $(grid);

    const $baseTile = $('.product-item-wrapper').first();
    const offset = $tile.offset();
    const gridOffset = $grid.offset();
    const cellHeight = $baseTile.outerHeight();

    return Math.floor((offset.top - gridOffset.top) / cellHeight) + 1;
};

/**
 * Adjust marketing tile after page load
 */
const adjustMarketingTileHeight = () => {
    const $gridContainer = $('.product-grid');
    const $marketingTile = $('.marketing-tile');

    $marketingTile.each((_, tile) => {
        const $tile = $(tile);

        const adjustTileHeight = () => {
            if ($tile.find('.size-ccb-1x1').length) {
                const mtPosition = parseInt($tile.data('plp-position'), 10);
                const $adjascentTile = $(`.product-item-wrapper[data-position="${mtPosition.toFixed(1)}"]`);
                const adjascentTileImgBottom = $adjascentTile.find('img').height();
                $tile.find('img').css('height', adjascentTileImgBottom);
            }

            if ($tile.find('.size-ccb-2x2').length) {
                const mtRowIndex = getMarketingTileRow($tile, $gridContainer);
                const mtPosition = parseInt($tile.data('plp-position'), 10);
                const $adjascentTile = $(`.product-item-wrapper[data-position="${mtPosition.toFixed(1)}"]`);

                const adjascentTileRow = getProductItemRow($adjascentTile, $gridContainer);

                if ([mtRowIndex, mtRowIndex + 1].includes(adjascentTileRow)) {
                    const refTileHeight = $adjascentTile.height();
                    const $refTileImg = $adjascentTile.find('img');
                    const refTileImgHeight = $refTileImg.height();
                    const totalHeight = refTileHeight + refTileImgHeight;
                    $tile.find('img').css('height', totalHeight);
                }
            }
        };

        adjustTileHeight();

        const observer = new MutationObserver(adjustTileHeight);
        const config = { attributes: true, childList: true, subtree: true };

        const $elementsToObserve = [];

        if ($tile.find('.size-ccb-2x2').length) {
            const mtPosition = parseInt($tile.data('plp-position'), 10);
            const $adjascentTile = $(`.product-item-wrapper[data-position="${mtPosition.toFixed(1)}"]`);

            $elementsToObserve.push($adjascentTile[0]);
            const $refTileImg = $adjascentTile.find('img');
            if ($refTileImg.length) {
                $elementsToObserve.push($refTileImg[0]);
            }

            $elementsToObserve.push($gridContainer[0]);

            if ($elementsToObserve.length > 0) {
                $elementsToObserve.forEach((element) => {
                    observer.observe(element, config);
                });
            }
        }

        $tile.data('observer', observer);
    });
};

let resizeTimeout;
$(() => {
    $(window).on('load', adjustMarketingTileHeight());
    $(window).on('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(adjustMarketingTileHeight, 200);
    });
    $('body').on('search:updateDom', () => {
        adjustMarketingTileHeight();
    });
});
